export var clientDpLedgerDetailsMapper = function (response) {
    var _a;
    if (typeof (response === null || response === void 0 ? void 0 : response.data) === "string") {
        return {
            showdata: [],
            FileBase64String: response.data,
        };
    }
    if (typeof (response === null || response === void 0 ? void 0 : response.data) !== "string" && ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        return {
            showdata: response.data.map(function (item) {
                return {
                    Date: item.date,
                    BookType: item.bookType,
                    BookCode: item.bookCode,
                    VoucherType: item.voucherType,
                    Narration: item.narration,
                    ChequeNo: item.chequeNo,
                    ReceiptsInRs: item.receiptsInRs,
                    PaymentsInRs: item.paymentsInRs,
                    CummulativeBalance: item.cummulativeBalance,
                };
            }),
            FileBase64String: "",
        };
    }
    return {};
};
